import React from 'react';
import {isString} from 'lodash';
import {
  removeWfTokens,
  removeAllTokens,
} from '@packages/systems/core/utils/EmbedUtils/all';
import {trimmedOneLiner} from '@packages/utilities/string-utils';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {Atom, AtomRenderProps} from '@packages/systems/wfdl';
import {TRecord, TText, TBoolean} from '@packages/systems/wfdl-ast';
import {
  EvaluatedNodeData,
  getBoolean,
  getInPojo,
  getStringOrElse,
} from '@packages/utilities/data-utils';
import {useRuntimeEnvironment} from '@packages/systems/render';

const getStaticValue = (data: EvaluatedNodeData, exportMode: boolean) => {
  const value = getStringOrElse(getInPojo(data, ['value']), '');
  return !exportMode && getBoolean(getInPojo(data, ['shouldReplaceTokens']))
    ? removeAllTokens(value)
    : removeWfTokens(value || '');
};

const Title = Atom.createRender(
  ({attributes, classes, generateAttributes, token, data}: AtomRenderProps) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const exportMode = runtimeEnvironment === WebflowEnvironments.EXPORT;
    const value = isString(token) ? token : getStaticValue(data, exportMode);
    return (
      <title {...generateAttributes(attributes, classes)}>
        {trimmedOneLiner(value)}
      </title>
    );
  }
);

const config = Atom.create({
  showEmpty: false,
  render: Title,
  dataType: TRecord({value: TText, shouldReplaceTokens: TBoolean}),
});

export default config;
